<template>
  <v-dialog v-model="dialog" max-width="400px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" v-bind="attrs" v-on="on"> Price </v-btn>
    </template>
    <v-card>
      <!-- <v-card-title class="headline">Price Tiers</v-card-title> -->
      <ModelTitle title="Price Tiers" @close="close()" />

      <v-card-text>
        <v-form>
          <v-container>
            <v-row v-if="PriceTiers.length">
              <v-col v-for="tier in PriceTiers" :key="tier.id" cols="12">
                <v-row align="center">
                  <v-col cols="12">
                    <v-text-field
                      v-model="tier.price"
                      :label="tier.name"
                      class="right-input"
                      outlined
                      dense
                      @focus="$event.target.select()"
                      hide-details
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <p>No fixed price tiers found.</p>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="close()">Close</v-btn>
        <v-btn color="primary" dark @click="submit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PriceTierService from "@/modules/Product/PriceTier/service.js";

export default {
  name: "FixedPriceTierDialog",
  props: ["price", "ProductId"],
  data() {
    return {
      PriceTiers: [],
      loading: false,
      dialog: false,
    };
  },
  // computed: {
  //   // dialog: {
  //   //   get() {
  //   //     return this.value;
  //   //   },
  //   //   set(val) {
  //   //     this.$emit("input", val);
  //   //   }
  //   // },
  //   filteredTiers() {
  //     return this.PriceTiers.filter((tier) => tier.discountType === "fixed");
  //   },
  // },
  watch: {
    dialog(val) {
      if (val) {
        console.log("dialog", this.ProductId);
        if (this.ProductId) {
          this.getProductPriceTiers();
        } else {
          this.getList();
        }

        // this.PriceTiers = {};
        // this.tiers.forEach(tier => {
        //   if (tier.discountType === 'fixed') {
        //     this.$set(this.PriceTiers, tier.id, tier.price || 0);
        //   }
        // });
      }
    },
    // tiers: {
    //   immediate: true,
    //   handler(val) {
    //     val.forEach(tier => {
    //       if (tier.discountType === 'fixed' && !this.PriceTiers[tier.id]) {
    //         this.$set(this.PriceTiers, tier.id, tier.price || 0);
    //       }
    //     });
    //   }
    // }
  },
  methods: {
    getProductPriceTiers() {
      this.loading = true;
      return PriceTierService.productById(this.ProductId).then((response) => {
        this.loading = false;
        if (response.data) {
          response.data.forEach((tier) => {
            if (tier.discountType === "fixed") {
              tier.price = tier.ProductPrices[0].price || 0; // Ensure price is defined
              this.PriceTiers.push(tier);
              // this.$set(this.PriceTiers, tier.id, tier.price || 0);
            }
          });
        }

        // if (response.data) {
        //   response.data.forEach((tier) => {
        //     if (tier.discountType === "fixed") {
        //       tier.price = this.price || 0; // Ensure price is defined
        //       this.PriceTiers.push(tier);
        //       // this.$set(this.PriceTiers, tier.id, tier.price || 0);
        //     }
        //   });
        // }

        // this.PriceTiers = response.data;
        console.log("this.PriceTiers", response);
        return response;
      });
    },
    getList() {
      this.loading = true;
      return PriceTierService.getAll().then((response) => {
        this.loading = false;
        if (response.data) {
          response.data.forEach((tier) => {
            if (tier.discountType === "fixed") {
              tier.price = this.price || 0; // Ensure price is defined
              this.PriceTiers.push(tier);
              // this.$set(this.PriceTiers, tier.id, tier.price || 0);
            }
          });
        }

        // this.PriceTiers = response.data;
        // console.log("this.PriceTiers", this.PriceTiers);
        return response;
      });
    },
    close() {
      this.dialog = !this.dialog;
      this.PriceTiers = [];
    },
    submit() {
      this.$emit("save", this.PriceTiers);
      this.PriceTiers = [];
      this.close();
    },
  },
};
</script>
